var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailverify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150.336C116.421 150.336 150 116.682 150 75.1681C150 33.6539 116.421 0 75 0C33.5786 0 0 33.6539 0 75.1681C0 116.682 33.5786 150.336 75 150.336Z",
    fill: "#F0ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6979 137.921C65.2901 137.921 65.7702 137.439 65.7702 136.846C65.7702 136.252 65.2901 135.771 64.6979 135.771C64.1056 135.771 63.6255 136.252 63.6255 136.846C63.6255 137.439 64.1056 137.921 64.6979 137.921Z",
    fill: "#56CABB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4893 144.33C66.0816 144.33 66.5617 143.849 66.5617 143.255C66.5617 142.661 66.0816 142.18 65.4893 142.18C64.8971 142.18 64.417 142.661 64.417 143.255C64.417 143.849 64.8971 144.33 65.4893 144.33Z",
    fill: "#56CABB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5157 139.62C69.108 139.62 69.5881 139.139 69.5881 138.545C69.5881 137.952 69.108 137.47 68.5157 137.47C67.9235 137.47 67.4434 137.952 67.4434 138.545C67.4434 139.139 67.9235 139.62 68.5157 139.62Z",
    fill: "#56CABB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25718 71.578C6.82152 71.578 7.279 71.1195 7.279 70.5539C7.279 69.9883 6.82152 69.5298 6.25718 69.5298C5.69284 69.5298 5.23535 69.9883 5.23535 70.5539C5.23535 71.1195 5.69284 71.578 6.25718 71.578Z",
    fill: "#182A88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54185 66.3673C10.1062 66.3673 10.5637 65.9088 10.5637 65.3432C10.5637 64.7776 10.1062 64.3191 9.54185 64.3191C8.97751 64.3191 8.52002 64.7776 8.52002 65.3432C8.52002 65.9088 8.97751 66.3673 9.54185 66.3673Z",
    fill: "#182A88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46616 68.0104C5.0305 68.0104 5.48799 67.5519 5.48799 66.9863C5.48799 66.4207 5.0305 65.9622 4.46616 65.9622C3.90182 65.9622 3.44434 66.4207 3.44434 66.9863C3.44434 67.5519 3.90182 68.0104 4.46616 68.0104Z",
    fill: "#182A88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6526 21.0813C74.3968 21.0813 75.0001 20.4767 75.0001 19.7309C75.0001 18.985 74.3968 18.3804 73.6526 18.3804C72.9084 18.3804 72.3052 18.985 72.3052 19.7309C72.3052 20.4767 72.9084 21.0813 73.6526 21.0813Z",
    fill: "#5F3FAF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8914 15.156C70.6356 15.156 71.2389 14.5514 71.2389 13.8056C71.2389 13.0597 70.6356 12.4551 69.8914 12.4551C69.1472 12.4551 68.5439 13.0597 68.5439 13.8056C68.5439 14.5514 69.1472 15.156 69.8914 15.156Z",
    fill: "#5F3FAF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.888 117.371H28.8386C24.218 117.371 20.4731 113.618 20.4731 108.986V35.2558C20.4731 33.9897 21.495 32.9656 22.7582 32.9656H134.974C136.237 32.9656 137.259 33.9897 137.259 35.2558V108.986C137.253 113.618 133.508 117.371 128.888 117.371Z",
    fill: "white",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4731 35.2163L78.8632 80.7951L137.253 35.2163",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4731 35.2163L78.8632 80.7951L137.253 35.2163",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2499 98.644L25.1108 116.493",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7024 64.2742L39.1636 93.9735",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.658 80.7952L132.936 116.493",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.344 64.2742L107.092 75.0837",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3291 87.0804C84.033 87.0804 87.8462 83.2586 87.8462 78.5442C87.8462 73.8298 84.033 70.0081 79.3291 70.0081C74.6252 70.0081 70.812 73.8298 70.812 78.5442C70.812 83.2586 74.6252 87.0804 79.3291 87.0804Z",
    fill: "#DDD0FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9585 87.0804C83.6623 87.0804 87.4756 83.2586 87.4756 78.5442C87.4756 73.8298 83.6623 70.0081 78.9585 70.0081C74.2546 70.0081 70.4414 73.8298 70.4414 78.5442C70.4414 83.2586 74.2546 87.0804 78.9585 87.0804Z",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4443 134.055C31.773 134.055 40.146 125.663 40.146 115.311C40.146 104.959 31.773 96.5676 21.4443 96.5676C11.1157 96.5676 2.74268 104.959 2.74268 115.311C2.74268 125.663 11.1157 134.055 21.4443 134.055Z",
    fill: "#56CABB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.106 115.66L19.479 120.955L30.9268 109.285",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailverify);
export default __webpack_public_path__ + "static/media/emailverify.f8982af4.svg";
export { ForwardRef as ReactComponent };